import DescriptionFormType from "./Description.form";
import formatInteger from "../../../../functions/formatInteger.function";
import mapUndefinedEnum from "../../../../functions/mapUndefinedEnum.function";
import UserReferenceResponse from "../../../../api/models/UserReferenceResponse";

type TestRequestDescriptionResponse = Omit<
  TestRequestRaw.Schemas.TestRequestDescriptionResponse,
  "assignee" | "furtherInternalContacts" | "salesTeam" | "suggestedApprover"
> & {
  assignee: UserReferenceResponse;
  furtherInternalContacts: UserReferenceResponse[];
  salesTeam: UserReferenceResponse[];
  suggestedApprover: UserReferenceResponse;
};

export default function mapFromResponse(response: TestRequestDescriptionResponse | null): DescriptionFormType {
  return {
    applicationField: response?.applicationField || "",
    testRequestPriority: response?.testRequestPriority || "NONE",
    assignee: response?.assignee || null,
    backgroundInformation: response?.backgroundInformation || "",
    businessType: response?.businessType || "",
    businessUnit: response?.businessUnit || "",
    crmProjectNo: formatInteger(response?.crmProjectNo),
    cscLaboratory: mapUndefinedEnum(response?.cscLaboratory),
    currentSolution: response?.currentSolution || "",
    customerClassification: response?.customerClassification || "",
    customerPartList: response?.customerPartList || "",
    deadline: response?.deadline || "",
    debitorNumber: formatInteger(response?.debitorNumber),
    directCustomer: response?.directCustomer || null,
    directCustomerCGR: response?.directCustomerCGR || "",
    directCustomerLocation: response?.directCustomerLocation || null,
    distributor: response?.distributor || null,
    estimatedFinishingDate: response?.estimatedFinishingDate || "",
    estimatedTestEffortInDays: formatInteger(response?.estimatedTestEffortInDays),
    furtherInternalContact: response?.furtherInternalContact || "",
    furtherInternalContacts: response?.furtherInternalContacts || [],
    marketSegment: response?.marketSegment || "",
    oem: response?.oem || null,
    opportunityProducts: response?.opportunityProducts || [],
    pnsPotentialCurrencyCode: mapUndefinedEnum(response?.pnsPotentialCurrencyCode),
    pnsPotential: formatInteger(response?.pnsPotential),
    processDetail: response?.processDetail || "",
    processType: response?.processType || "",
    products: response?.products || "",
    productReferences: response?.productReferences || [],
    prototypeProductReferences: (response?.prototypeProductReferences as []) || [],
    competitorProductReferences: (response?.competitorProductReferences as []) || [],
    projectConfidentiality: mapUndefinedEnum(response?.projectConfidentiality, ["NONE", "NDA", "CONFIDENTIAL"]),
    reportLanguage: mapUndefinedEnum(response?.reportLanguage),
    reportUsage: mapUndefinedEnum(response?.reportUsage),
    salesTeam: response?.salesTeam || [],
    specifications: response?.specifications || [],
    specificationNeeded: Boolean(response?.specificationNeeded),
    substrates: response?.substrates || "",
    suggestedApprover: response?.suggestedApprover || null,
    testLocation: response?.testLocation || "",
    testProgram: response?.testProgram || "",
    title: response?.title || "",
    testPurpose: mapUndefinedEnum(response?.testPurpose),
    externalDevelopmentBudget: formatInteger(response?.externalDevelopmentBudget),
    externalDevelopmentBudgetCurrencyCode: mapUndefinedEnum(response?.externalDevelopmentBudgetCurrencyCode),
  };
}
